// @ts-nocheck
import React, { createContext, useContext, useEffect, useState } from 'react';
import { get, inRange, invoke, subtract } from 'lodash';

type WebView = {
  isLoading?: boolean;
  user?: any;
  checkUserHasActiveSession?: () => boolean | undefined;
};
export const WebViewContext = createContext({});

const WebViewProvider = ({ children }) => {
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const setPartnerToken = (userObj) => {
    const addEvent = new CustomEvent('setPartnerToken', { detail: userObj });
    window.dispatchEvent(addEvent);
  };
  window.setPartnerToken = setPartnerToken;

  const refreshPartnerToken = (userObj) => {
    const event = new CustomEvent('refreshPartnerToken', { detail: userObj });
    window.dispatchEvent(event);
  };
  window.refreshPartnerToken = refreshPartnerToken;

  const updateUserInfo = (userInfo) => {
    if (userInfo) {
      setUser({
        ...userInfo,
        ...user,
        UUID: userInfo.uuid,
        authToken: userInfo.token,
        customerId: userInfo?.guid,
        shopStoreId: userInfo?.storeID,
      });

      setIsLoading(false);
    }
  };

  useEffect(() => {
    invoke(window, 'addEventListener', 'beforeunload', () => {
      localStorage.setItem('lastReloadTime', new Date().getTime());
    });
  });

  useEffect(() => {
    const lastReloadTime = localStorage.getItem('lastReloadTime');
    const localUserInfo = localStorage.getItem('snsMobileUserInfo');
    const timeSinceLastReload = subtract(new Date().getTime(), lastReloadTime);

    if (localUserInfo && inRange(timeSinceLastReload, 0, 60000)) {
      const userInfo = JSON.parse(localStorage.getItem('snsMobileUserInfo'));

      if (checkTokenValid(get(userInfo, 'token'))) {
        updateUserInfo(userInfo);
      }
    } else {
      requestNewToken();
    }
  }, []);

  useEffect(() => {
    const device = new URLSearchParams(window.location.search).get('mobile')
      ? encodeURIComponent(new URLSearchParams(window.location.search).get('mobile'))
      : '';
    if (!device) return;
    const handleMessageReceived = (event) => {
      if (event?.detail) {
        let userInfo = JSON.parse(event.detail);

        localStorage.removeItem('snsMobileUserInfo');
        localStorage.setItem('snsMobileUserInfo', event.detail);

        console.log(new Date().toISOString(), 'Mobile: User authenticated', get(userInfo, 'uuid'));

        updateUserInfo(userInfo);
      }
    };

    const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    const receiveMessage = window[eventMethod];
    const messageEvent = 'setPartnerToken';
    receiveMessage(messageEvent, handleMessageReceived, false);

    return () => window.removeEventListener(messageEvent, handleMessageReceived, false);
  }, []);

  useEffect(() => {
    const device = new URLSearchParams(window.location.search).get('mobile')
      ? encodeURIComponent(new URLSearchParams(window.location.search).get('mobile'))
      : '';
    if (!device) return;
    const handleMessageReceived = (event) => {
      if (event?.detail) {
        let userInfo = JSON.parse(event.detail);

        localStorage.removeItem('snsMobileUserInfo');
        localStorage.setItem('snsMobileUserInfo', userInfo);

        console.log(new Date().toISOString(), 'Mobile: User authenticated', get(userInfo, 'uuid'));

        updateUserInfo(userInfo);
      }
    };
    const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    const receiveMessage = window[eventMethod];
    const messageEvent = 'refreshPartnerToken';
    receiveMessage(messageEvent, handleMessageReceived, false);

    return () => receiveMessage(messageEvent, handleMessageReceived, false);
  }, []);

  // TODO: use API call to check token validity once available
  const checkTokenValid = (token?: string) => {
    const parseJwt = (jwtToken) => {
      const base64Url = jwtToken.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      return JSON.parse(window.atob(base64));
    };
    const parsedToken = parseJwt(token || user.authToken);
    const currentDate = new Date();
    const expiryDate = new Date(Number(parsedToken['exp'] * 1000));
    return expiryDate > currentDate;
  };

  const getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }

    return 'unknown';
  };

  const checkUserHasActiveSession = (token?: string) => {
    const isTokenValid = checkTokenValid(token);
    if (isTokenValid) return true;

    localStorage.removeItem('snsMobileUserInfo');

    requestNewToken();
  };

  const requestNewToken = () => {
    const deviceType = getMobileOperatingSystem();
    if (deviceType) {
      if (deviceType.toLowerCase() === 'ios') {
        console.warn('device type IOS >> calling iOS refreshPartnerToken');
        window.webkit.messageHandlers.refreshPartnerToken.postMessage(user);
      }
      if (deviceType.toLowerCase() === 'android' && Android != null) {
        console.warn('device type Android >> calling Android refreshPartnerToken');
        Android.refreshPartnerToken();
      }
    }
  };

  return (
    <WebViewContext.Provider value={{ user, isLoading, checkUserHasActiveSession }}>{children}</WebViewContext.Provider>
  );
};

const useWebView = () => {
  const webViewContext = useContext<WebView>(WebViewContext);
  return webViewContext;
};

export { useWebView };
export default WebViewProvider;
